import { observer } from "mobx-react-lite"

import type { VenammSellStore } from "@/domains/venamm"
import { MessageBoxIcon } from "@/domains/common/components/message-box-icon"
import { ShortMessageBox } from "@/domains/common/components/short-message-box"
import { BodySM } from "@/domains/design/components/body-sm"

interface VenammSellingProps {
  store: VenammSellStore
}

export const VenammSelling = observer(({ store }: VenammSellingProps) => {
  return (
    <ShortMessageBox variant="info" icon={<MessageBoxIcon size={"md"} variant="info" />}>
      <BodySM className="text-t200">Selling your veSCALE...</BodySM>
    </ShortMessageBox>
  )
})

